import Immutable from 'immutable';
import { Discipline, RawDiscipline } from 'records/Discipline';

export type DisciplineDesignator = string;

export interface RawSheetsSettings {
  setType: string;
  disciplines: RawDiscipline[];
}

export interface SheetsSettingsData {
  setType: string;
  disciplines: Immutable.OrderedMap<DisciplineDesignator, Discipline>;
}

const defaultValues: SheetsSettingsData = {
  setType: '',
  disciplines: Immutable.OrderedMap<DisciplineDesignator, Discipline>(),
};

export const SheetsSettingsFactory = Immutable.Record(
  defaultValues,
  'SheetsSettingsResponse'
);

export class SheetsSettings extends SheetsSettingsFactory {
  static deserialize(
    rawSheetSettingsResponse: RawSheetsSettings
  ): SheetsSettings {
    const disciplines = rawSheetSettingsResponse.disciplines
      .map(Discipline.deserialize)
      .reduce(
        (acc, discipline) => acc.set(discipline.designator, discipline),
        Immutable.OrderedMap<DisciplineDesignator, Discipline>()
      );

    return new SheetsSettings({
      ...rawSheetSettingsResponse,
      setType: rawSheetSettingsResponse.setType,
      disciplines,
    });
  }

  serialize(): RawSheetsSettings {
    return this.toJS();
  }
}
